import { openModal } from '@core/components/ModalStack';
import { SelectProjectTypeModalProps } from './SelectProjectTypeModal';

export async function openSelectProjectTypeModal(props: SelectProjectTypeModalProps) {
  const { SelectProjectTypeModal } = await import('./SelectProjectTypeModal');

  openModal(SelectProjectTypeModal, props);
}
